<template>
  <div class="ls_spin_container">
    <!-- SOURCE AND TARGET TABLES -->
    <Row :gutter="32" style="padding: 6px">
      <!--SOURCE TABLE-->
      <Col :sm="24" :lg="8" v-if="action === 'create'">
        <!-- SEARCH -->
        <Input
          v-model="kit_composition.search_value"
          suffix="ios-search"
          placeholder="Введите наименование/артикул/код"
          class="mb-30"
        />
        <div class="card-container card-container__one-col-table">

          <Table
            class="one-col-table desktop_table"
            :data="kit_composition.source_table.data"
            :columns="kit_composition.source_table.columns"
            :loading="kit_composition.source_table.loading"
            :show-header="false"
            @on-row-click="addToKitTargetTable"
          ></Table>

          <Table
            v-if="kit_composition.search_value"
            class="one-col-table mobile-table"
            :data="kit_composition.source_table.data"
            :columns="kit_composition.source_table.columns"
            :loading="kit_composition.source_table.loading"
            :show-header="false"
            @on-row-click="addToKitTargetTable"
          ></Table>


          <Button
            class="desktop_table"
            v-show="
              kit_composition.source_table.current_page *
                kit_composition.source_table.limit <
                kit_composition.source_table.total_records
            "
            style="width: 100%"
            type="info"
            @click="kit_composition.source_table.current_page++"
          >Показать еще
          </Button>
        </div>
      </Col>

      <!--TARGET TABLE-->
      <Col :sm="24" :lg="16" class="target_table">
        <Form v-if="schema" :model="formData" ref="formData" :rules="formDataRules">


          <Row class="mb-30" type="flex" align="middle" :gutter="24">

            <Col :xs="24" :sm="24" :md="0" class="mb-10">
              <!--APPLIED-->
              <FormItem style="margin-bottom: 0;">
                <div class="switch-custom">
                  <i-switch v-model="formData.applied"></i-switch>
                  <span>{{ applied_label }}</span>
                </div>

              </FormItem>

            </Col>

            <Col :xs="24" :sm="24" :md="0" class="mb-10">
              <!--IS_ORDER, STATE-->
              <div
                class="d-flex align-center select-filter"
                v-if="display_is_order"
              >
                <!--IS_ORDER-->
                <FormItem style="margin-bottom: 0;">
                  <Checkbox size="large" v-model="is_order">Заказ</Checkbox>
                </FormItem>

                <!--STATE-->
                <FormItem
                  v-if="is_order"
                  style="margin-bottom: 0; width: 120px; margin-left: 10px"
                >
                  <Select v-model="formData.state" filterable @on-change="changeState">
                    <Option
                      v-for="item in schema.state.choices"
                      :value="item.value"
                      :key="item.value"
                    >{{ item.display_name }}
                    </Option
                    >
                  </Select>
                </FormItem>

              </div>
            </Col>

            <Col :xs="24" :sm="24" :md="0" class="mb-10">
              <!--ORDER_DATE-->
              <FormItem style="margin-bottom: 0;">
                <DatePicker
                  class="datepicker_input"
                  :clearable="false"
                  type="datetime"
                  :placeholder="schema.order_date.label"
                  format="yyyy-MM-dd HH:mm"
                  :value="formData.order_date"
                  @on-change="setOrderDate"
                ></DatePicker>
              </FormItem>
            </Col>

          </Row>


          <h1>
            {{ order_type_labels[formData.type] }} №
            <input class="form__order_number" v-model="formData.number"/>
          </h1>

          <Row :gutter="32" style="margin-top: 20px; margin-bottom: 20px">

            <!--SENDER-->
            <Col :xs="24" :sm="12" v-if="display_sender">
              <FormItem v-if="action==='create'" :label="sender_label" prop="sender.id">
                <Select v-model="formData.sender.id" filterable>
                  <OptionGroup :label="sender_label">
                    <Option
                      v-for="item in formSelectOptions[DISPLAY_SENDER[formData.type]]"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}
                    </Option
                    >
                  </OptionGroup>
                </Select>
              </FormItem>

              <h2 class="mb-15" v-if="action==='edit'">{{ sender_label }}: {{ formData.sender.name }}</h2>
            </Col>

            <!--RECIPIENT-->
            <Col :xs="24" :sm="12" v-if="display_recipient">
              <FormItem v-if="action==='create'" :label="recipient_label" prop="recipient.id">
                <Select v-model="formData.recipient.id" filterable>
                  <OptionGroup :label="recipient_label">
                    <Option
                      v-for="item in formSelectOptions[DISPLAY_RECIPIENT[formData.type]]"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}
                    </Option
                    >
                  </OptionGroup>
                </Select>
              </FormItem>

              <h2 class="mb-15 text-right" v-if="action==='edit'">{{ recipient_label }}: {{ formData.recipient.name
                }}</h2>
            </Col>
          </Row>
        </Form>

        <div v-if="action === 'create'">
          <Tabs
            style="height: 100%;"
            v-if="kit_composition.target_table.length > 0"
          >
            <TabPane label="Товары">
              <div>
                <!-- TABLE OF SELECTED PRODUCTS-->

                <Row
                  class="desktop_table"
                  :gutter="10"
                  type="flex"
                  justify="space-between"
                  style="text-align: center; color: rgba(77,79,92,0.5); margin-bottom: 15px"
                >
                  <Col span="1">#</Col>
                  <Col :lg="5" :xl="6" style="text-align: left;">Наименование</Col>
                  <Col span="3">Ед.изм.</Col>
                  <Col :lg="4" :xl="3">Количество</Col>
                  <Col span="3">Цена</Col>
                  <Col span="3" v-if="display_discount_per_product">Скидка, %</Col>
                  <Col span="3" style="text-align: right;">Всего</Col>
                  <Col span="2"></Col>
                </Row>
                <Divider style="margin: 0 0 10px 0;"></Divider>

                <!-- DESKTOP TABLE OF SELECTED PRODUCTS-->
                <Row
                  class="desktop_table"
                  v-for="(product, counter) in kit_composition.target_table"
                  :key="product.id"
                  :gutter="10"
                  type="flex"
                  justify="space-between"
                  style="text-align: center;"
                >
                  <Divider v-if="counter > 0" style="margin: 13px 0;"></Divider>
                  <Col span="1" style="margin-top: 7px;">{{ counter + 1 }}</Col>
                  <Col :lg="5" :xl="6" style="text-align: left;margin-top: 7px;">{{ product.name }}</Col>
                  <Col span="3" style="text-align: center;margin-top: 7px;">{{ product.unit ? product.unit : "-" }}
                  </Col>
                  <Col :lg="4" :xl="3" style="text-align: center;">
                      <InputNumber
                        @input="changeCountTargetTable($event, counter)"
                        :min="1"
                        :value="kit_composition.target_table[counter].count"
                      ></InputNumber>
                  </Col>
                  <Col span="3">
                    <InputNumber
                      @input="changePriceTargetTable($event, counter)"
                      style="width: 100%"
                      :min="1"
                      v-model="kit_composition.target_table[counter].base_price"
                      :formatter="value => formatNumber(value)"
                    ></InputNumber>
                  </Col>
                  <Col span="3" style="text-align: center;" v-if="display_discount_per_product">
                    <InputNumber
                      @input="changeDiscountTargetTable($event, counter)"
                      :min="1"
                      :max="100"
                      v-model="kit_composition.target_table[counter].discount"
                    ></InputNumber>
                  </Col>
                  <Col span="3" style="text-align: right;margin-top: 7px;"
                  >{{ formatNumber(product.total_price.toFixed(2)) }} {{ currency }}
                  </Col
                  >
                  <Col span="2" style="text-align: right;">
                    <Button
                      style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                      icon="md-trash"
                      @click="deleteFromKitTargetTable(product.id)"
                    ></Button>
                  </Col>
                </Row>

                <!-- MOBILE TABLE OF SELECTED PRODUCTS-->
                <div class="mobile-table">
                  <div class="card-container"
                       v-for="(product, counter) in kit_composition.target_table"
                       :key="product.id">
                    <div>
                      <h2>{{product.name}}</h2>
                      <p>Ед.изм.: {{product.unit ? product.unit : "-"}}</p>

                      <p>Количество:
                        <InputNumber
                          @input="changeCountTargetTable($event, counter)"
                          :min="1"
                          :value="kit_composition.target_table[counter].count"
                        ></InputNumber>
                      </p>

                      <p>Цена:
                        <InputNumber
                          @input="changePriceTargetTable($event, counter)"
                          style="width: 100%"
                          :min="1"
                          v-model="kit_composition.target_table[counter].base_price"
                          :formatter="value => formatNumber(value)"
                        ></InputNumber>
                      </p>

                      <p>Скидка, %:
                        <InputNumber
                          @input="changeDiscountTargetTable($event, counter)"
                          :min="1"
                          :max="100"
                          v-model="kit_composition.target_table[counter].discount"
                        ></InputNumber>
                      </p>

                      <h2>
                        Всего: {{ formatNumber(product.total_price.toFixed(2)) }} {{ currency }}
                      </h2>
                    </div>

                    <div>
                      <Button
                        style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                        icon="md-trash"
                        @click="deleteFromKitTargetTable(product.id)"
                      ></Button>
                    </div>
                  </div>
                </div>

                <!-- TOTAL ROWS -->
                <div style="padding-top: 30px">
                  <!--TOTAL SUM-->
                  <Row :gutter="32" class="total_row">
                    <Col span="12">
                      <h3>Всего:</h3>
                    </Col>
                    <Col span="12" style="text-align: right;">
                      <h3>
                        {{ formatNumber(total_sum.toFixed(2)) }} {{ currency }}
                      </h3>
                    </Col>
                  </Row>

                  <!--PAID SUM-->
                  <Row :gutter="32" class="total_row">
                    <Col span="12">
                      Оплачено:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      {{ formatNumber(paid_sum.toFixed(2)) }} {{ currency }}
                    </Col>
                  </Row>

                  <!--INDIVIDUAL TOTAL DISCOUNT-->
                  <Row v-if="display_individual_discount_sum" :gutter="32" class="total_row">
                    <Col span="12">
                      Скидка по документу:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      <InputNumber
                        @input="changeDiscountByDocTargetTable"
                        :min="0"
                        :max="100"
                        v-model="individual_total_discount"
                      />
                      %
                    </Col>
                  </Row>

                  <!--TOTAL DISCOUNT-->
                  <Row v-if="display_discount_sum" :gutter="32" class="total_row">
                    <Col span="12">
                      Общая скидка:
                    </Col>
                    <Col span="12" style="text-align: right;">
                      {{ total_discount }} % ({{
                      formatNumber(total_discount_sum)
                      }}
                      {{ currency }})
                    </Col>
                  </Row>
                </div>

                <!-- DESCRIPTION FORM-->
                <Form :model="formData" style="margin-top: 20px; padding: 5px">
                  <!-- DESCRIPTION -->
                  <FormItem>
                    <Input
                      type="textarea"
                      v-model="formData.description"
                      :rows="4"
                      :placeholder="schema.description.label"
                    />
                  </FormItem>
                </Form>
              </div>
            </TabPane>
            <TabPane label="Счета и оплата">
              <Form :model="formData.money_orders" label-position="top">
                <div
                  class="count-card"
                  v-for="(item, counter) in formData.money_orders"
                  :key="counter"
                >
                  <Row :gutter="16">
                    <Col :md="3">
                      <FormItem label="Оплачен">
                        <i-switch
                          v-model="formData.money_orders[counter].applied"
                        ></i-switch>
                      </FormItem>
                    </Col>
                    <Col :md="7">
                      <FormItem label="Счет">
                        <Select
                          v-model="formData.money_orders[counter].account"
                          filterable
                          style="width: 100%;"
                        >
                          <OptionGroup label="Счета">
                            <Option
                              v-for="item in formSelectOptions.account"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}
                            </Option
                            >
                          </OptionGroup>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col :md="5">
                      <FormItem label="Сумма">
                        <InputNumber
                          :min="0"
                          :value="formData.money_orders[counter].sum"
                          @change.native="changePaymentSum($event.target.value, counter)"
                          style="width: 100%;"
                          :formatter="value => formatNumber(value)"
                        />
                      </FormItem>
                    </Col>
                    <Col :xs="20" :sm="20" :md="7">
                      <FormItem label="Дата">
                        <DatePicker
                          :clearable="false"
                          type="datetime"
                          format="yyyy-MM-dd HH:mm"
                          :value="formData.money_orders[counter].date"
                          @on-change="setOrderDate"
                          style="width: 100%;"
                        ></DatePicker>
                      </FormItem>
                    </Col>
                    <Col :xs="4" :sm="4" :md="2" v-if="counter !== 0" class="text-right">
                      <Button
                        @click="deleteMoneyOrder(counter)"
                        size=""
                        style="padding: 0; color: #EF6E57; box-shadow: none; border: none; margin-top: 32px"
                        icon="md-trash"

                      ></Button>
                    </Col>
                  </Row>
                </div>
                <Button
                  type="success"
                  class="ls_create_button mb-15"
                  @click="addMoneyOrder"
                >Добавить оплату
                </Button>
              </Form>
            </TabPane>
          </Tabs>
          <div
            v-else
            class="no-select"
          >

            <span class="desktop_table">
              <Icon type="md-arrow-back"/>
              Выберите товары
            </span>

            <span class="mobile-table">

              <Icon type="md-arrow-up"/> <br>
              Выберите товары <br> (введите наименование в строке поиска)
            </span>

          </div>
        </div>
        <div v-if="action === 'edit'">
          <div>
            <!-- TABLE OF PRODUCTS-->
            <Row
              class="desktop_table"
              :gutter="10"
              type="flex"
              justify="space-between"
              style="text-align: center; color: gray"
            >
              <Col class="mb-10" span="1">#</Col>
              <Col class="mb-10" span="6" style="text-align: left;">Наименование</Col>
              <Col class="mb-10" span="3">Ед.изм.</Col>
              <Col class="mb-10" span="3">Количество</Col>
              <Col class="mb-10" span="4">Цена</Col>
              <Col class="mb-10" span="3" v-if="display_discount_per_product">Скидка, %</Col>
              <Col class="mb-10" span="3" style="text-align: right;">Всего</Col>
              <Col class="mb-10" span="2"></Col>
            </Row>
            <Divider style="margin: 0 0 10px 0;"></Divider>

            <Row
              class="desktop_table"
              v-for="(product, counter) in kit_composition.target_table"
              :key="product.id"
              :gutter="10"
              type="flex"
              justify="space-between"
              style="text-align: center;"
            >
              <Divider v-if="counter > 0" style="margin: 13px 0;"></Divider>
              <Col span="1">{{ counter + 1 }}</Col>
              <Col span="6" style="text-align: left;">{{ product.name }}</Col>
              <Col span="3" style="text-align: center;">{{
                product.unit ? product.unit : "-"
                }}
              </Col>
              <Col span="3" style="text-align: center;">
                {{ formatNumber(kit_composition.target_table[counter].count) }}
              </Col>
              <Col span="4">
                {{ formatNumber(kit_composition.target_table[counter].base_price) }}
              </Col>
              <Col span="3" style="text-align: center;" v-if="display_discount_per_product">
                {{ formatNumber(kit_composition.target_table[counter].discount) }}
              </Col>
              <Col span="3" style="text-align: right;"
              >{{ formatNumber(parseFloat(product.total_price.toFixed(2))) }} {{ currency }}
              </Col
              >
              <Col span="2" style="text-align: right;">
                <!--<Button-->
                <!--type="error"-->
                <!--style="float: right;"-->
                <!--icon="ios-trash-outline"-->
                <!--ghost-->
                <!--@click="deleteFromKitTargetTable(product.id)"-->
                <!--&gt;</Button>-->
              </Col>
            </Row>


            <!-- MOBILE TABLE OF SELECTED PRODUCTS-->
            <div class="mobile-table">
              <div class="card-container"
                   v-for="(product, counter) in kit_composition.target_table"
                   :key="product.id">

                <div>
                  <h2>{{ product.name }}</h2>
                  <p>Ед.изм.: {{product.unit ? product.unit : "-"}}</p>
                  <p>Кол-во: {{ formatNumber(kit_composition.target_table[counter].count) }}</p>
                  <p>Цена: {{ formatNumber(kit_composition.target_table[counter].base_price) }}</p>
                  <p>Скидка: {{ formatNumber(kit_composition.target_table[counter].discount) }} %</p>
                  <h2>Всего: {{ formatNumber(parseFloat(product.total_price.toFixed(2))) }} {{ currency }}</h2>
                </div>

              </div>

            </div>


            <!-- TOTAL ROWS -->
            <div style="padding-top: 30px">
              <!--TOTAL SUM-->
              <Row :gutter="32" class="total_row">
                <Col span="12">
                  <h3>Всего:</h3>
                </Col>
                <Col span="12" style="text-align: right;">
                  <h3>
                    {{ formatNumber(total_sum.toFixed(2)) }} {{ currency }}
                  </h3>
                </Col>
              </Row>

              <!--PAID SUM-->
              <Row :gutter="32" class="total_row">
                <Col span="12">
                  Оплачено:
                </Col>
                <Col span="12" style="text-align: right;">
                  {{ formatNumber(paid_sum.toFixed(2)) }} {{ currency }}
                </Col>
              </Row>

              <!--TOTAL DISCOUNT-->
              <Row v-if="display_discount_sum" :gutter="32" class="total_row">
                <Col span="12">
                  Общая скидка:
                </Col>
                <Col span="12" style="text-align: right;">
                  {{ total_discount }} % ({{
                  formatNumber(total_discount_sum)
                  }}
                  {{ currency }})
                </Col>
              </Row>
            </div>

            <!-- DESCRIPTION FORM-->

            <Form :model="formData" style="margin-top: 20px; padding: 5px">
              <!-- DESCRIPTION -->
              <FormItem>
                <Input
                  type="textarea"
                  v-model="formData.description"
                  :rows="4"
                  :placeholder="schema.description.label"
                />
              </FormItem>
            </Form>


          </div>
        </div>


        <Button
          style="display: inline-block"
          type="success"
          @click="save"
          :disabled="disabled_save_button"
        >Сохранить
        </Button>

      </Col>
    </Row>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import {order_type_labels} from "./order_type_list.js";
    import {base_url} from "../../http.js";
    import {formatNumber} from "../../base/base_func.js";
    import {BaseFormData} from "../../base/base_form_v2.js";

    import {
        TYPE_SELL,
        TYPE_PURCHASE,
        TYPE_RETURN_SELL,
        TYPE_RETURN_PURCHASE,
        TYPE_CHANGES_IN,
        TYPE_CHANGES_OUT,
        TYPE_MOVING,
        BASE_PRICE,
        PURCHASE_PRICE
    } from './const.js'


    let base = BaseFormData();

    export default {
        name: "productOrderForm",

        data() {
            return {
                PRICE_ATTR: BASE_PRICE,
                // DISPLAY_MONEY_ORDERS: ['sell', 'purchase', 'return_sell', 'return_purchase'],
                // DISPLAY_TOTAL_SUM: ['sell', 'purchase', 'return_sell', 'return_purchase'],
                // DISPLAY_PAID_SUM: ['sell', 'purchase', 'return_sell', 'return_purchase'],
                DISPLAY_IS_ORDER: [TYPE_SELL, TYPE_PURCHASE],
                DISPLAY_INDIVIDUAL_TOTAL_DISCOUNT: [TYPE_SELL, TYPE_RETURN_SELL],
                DISPLAY_TOTAL_DISCOUNT: [TYPE_SELL, TYPE_RETURN_SELL],
                DISPLAY_SENDER: {
                    [TYPE_SELL]: 'store',
                    [TYPE_PURCHASE]: 'supplier',
                    [TYPE_RETURN_PURCHASE]: 'store',
                    [TYPE_RETURN_SELL]: 'customer',
                },
                DISPLAY_RECIPIENT: {
                    [TYPE_SELL]: 'customer',
                    [TYPE_PURCHASE]: 'store',
                    [TYPE_RETURN_PURCHASE]: 'supplier',
                    [TYPE_RETURN_SELL]: 'store',
                    // 'changes_in': 'store',
                    // 'changes_out': '',
                    // 'moving': 'store',
                    // 'changes_inventory': ''
                },
                SUBJECT_LABELS: {
                    'store': 'Магазин',
                    'supplier': 'Поставщик',
                    'customer': 'Покупатель'
                },
                DISPLAY_DISCOUNT_PER_PRODUCT: [TYPE_SELL, TYPE_RETURN_SELL],
                // DISPLAY_PURCHASE_PRICE: [TYPE_PURCHASE, TYPE_RETURN_PURCHASE],
                base_view_url: base_url + "/product_orders/",
                action: "create",
                id: "",
                loading: true,

                // Объект, отправляемый в бэк
                formData: {
                    type: TYPE_SELL,
                    number: "",
                    applied: true,
                    order_date: new Date(),

                    sender: {
                        type: "store",
                        id: ""
                    },
                    recipient: {
                        type: "customer",
                        id: ""
                    },

                    state: "",
                    // store: "",
                    // customer: "",

                    positions: [],
                    money_orders: [
                        {
                            applied: true,
                            account: "",
                            sum: 0,
                            date: new Date()
                        }
                    ]
                },

                // Вспомогательный объект для хранения промежуточной информации о комплекте
                kit_composition: {
                    search_value: "",
                    source_table: {
                        columns: [
                            {
                                key: "name",
                                className: "kit_source_table_column",
                                render: (h, params) => {
                                    return h("div", [
                                        h("div", {}, params.row.name),
                                        h(
                                            "span",
                                            {
                                                style: {color: "#a4a4a4"}
                                            },
                                            formatNumber(params.row[this.PRICE_ATTR]) + " " + this.currency
                                        )
                                    ]);
                                }
                            }
                        ],
                        data: [],
                        total_records: 0,
                        last_draw: 0,
                        loading: false,
                        current_page: 1,
                        limit: 15
                    },
                    target_table: []
                },
                order_type_labels: order_type_labels,

                formSelectOptions: {
                    store: [],
                    customer: [],
                    // state: []
                    supplier: []

                    // user: [],
                },
                is_order: false,
                individual_total_discount: 0,

                validForm: false,
                isChanged: false,
                formDataRules: {
                    "sender.id": [
                        {required: true, message: 'Пожалуйста, выберите отправителя', trigger: 'change'}
                    ],
                    "recipient.id": [
                        {required: true, message: 'Пожалуйста, выберите получателя', trigger: 'change'}
                    ],
                }
            };
        },
        asyncComputed: {
            schema: {
                get() {
                    return this.$http.options(this.base_view_url).then(response => {
                        return response.data.actions.POST;
                    });
                }
            }
        },
        computed: {
            applied_label() {
                return this.formData.applied
                    ? "Документ проведен"
                    : "Документ не проведен";
            },

            // Итоговые цифры по заказу
            total_sum() {
                let sum = 0;
                for (let item of this.kit_composition.target_table) {
                    sum += item.total_price;
                }
                return sum;
            },
            paid_sum() {
                return this.total_sum;
            },
            total_discount() {
                let base_price = 0;
                let total_price = 0;

                for (let item of this.kit_composition.target_table) {
                    base_price += parseFloat((item.count * item.base_price).toFixed(2));
                    total_price += item.total_price;
                }

                return (((base_price - total_price) / base_price) * 100).toFixed(2);
            },
            total_discount_sum() {
                let base_price = 0;
                let total_price = 0;

                for (let item of this.kit_composition.target_table) {
                    base_price += item.count * item.base_price;
                    total_price += item.total_price;
                }

                return (base_price - total_price).toFixed(2);
            },

            display_individual_discount_sum() {
                return this.DISPLAY_INDIVIDUAL_TOTAL_DISCOUNT.indexOf(this.formData.type) !== -1;
            },
            display_discount_sum() {
                return this.DISPLAY_TOTAL_DISCOUNT.indexOf(this.formData.type) !== -1;
            },
            // display_total_sum () {
            //   return this.DISPLAY_TOTAL_SUM.indexOf(this.formData.type) !== -1;
            // },
            // display_paid_sum () {
            //   return this.DISPLAY_PAID_SUM.indexOf(this.formData.type) !== -1;
            // },
            // display_money_orders () {
            //   return this.DISPLAY_MONEY_ORDERS.indexOf(this.formData.type) !== -1;
            // },
            display_is_order() {
                return this.DISPLAY_IS_ORDER.indexOf(this.formData.type) !== -1;
            },
            display_discount_per_product() {
                return this.DISPLAY_DISCOUNT_PER_PRODUCT.indexOf(this.formData.type) !== -1;
            },
            display_sender() {
                return this.DISPLAY_SENDER.hasOwnProperty(this.formData.type);
            },
            display_recipient() {
                return this.DISPLAY_RECIPIENT.hasOwnProperty(this.formData.type);
            },

            sender_label() {
                return this.SUBJECT_LABELS[this.DISPLAY_SENDER[this.formData.type]];
            },
            // sender_name () {
            //   switch (this.formData.sender.type) {
            //     case 'store':
            //       for (let store of this.formSelectOptions.store) {
            //         if (store.id === this.formData.sender.id) {
            //           return store.name;
            //         }
            //       }
            //       break;
            //     case 'customer':
            //       for (let customer of this.formSelectOptions.customer) {
            //         if (customer.id === this.formData.sender.id) {
            //           return customer.name;
            //         }
            //       }
            //       break;
            //     case 'supplier':
            //       for (let supplier of this.formSelectOptions.supplier) {
            //         if (supplier.id === this.formData.sender.id) {
            //           return supplier.name;
            //         }
            //       }
            //       break;
            //   }
            // },
            // recipient_name () {
            //   switch (this.formData.recipient.type) {
            //     case 'store':
            //       for (let store of this.formSelectOptions.store) {
            //         if (store.id === this.formData.recipient.id) {
            //           return store.name;
            //         }
            //       }
            //       break;
            //     case 'customer':
            //       for (let customer of this.formSelectOptions.customer) {
            //         if (customer.id === this.formData.recipient.id) {
            //           return customer.name;
            //         }
            //       }
            //       break;
            //     case 'supplier':
            //       for (let supplier of this.formSelectOptions.supplier) {
            //         if (supplier.id === this.formData.recipient.id) {
            //           return supplier.name;
            //         }
            //       }
            //       break;
            //   }
            // },
            recipient_label() {
                return this.SUBJECT_LABELS[this.DISPLAY_RECIPIENT[this.formData.type]];
            },
            currency() {
                return this.$store.state.currency;
            },
            disabled_save_button() {
                if (this.action === 'create') {
                    return this.kit_composition.target_table.length === 0 || !this.validForm;
                } else if (this.action === 'edit') {
                    return !this.isChanged;
                }
            }
        },
        methods: {
            // Получение спсика товаров для формирования заказа
            fetchProductsForKit(filtered = false) {
                const url = base_url + "/catalog/products/";
                this.kit_composition.source_table.loading = true;
                this.kit_composition.source_table.last_draw++;

                let params = {
                    format: "table",
                    draw: this.kit_composition.source_table.last_draw,
                    offset:
                        this.kit_composition.source_table.limit *
                        this.kit_composition.source_table.current_page -
                        this.kit_composition.source_table.limit,
                    limit: this.kit_composition.source_table.limit,
                    search: this.kit_composition.search_value
                };

                this.$http
                    .get(url, {params: params})
                    .then(result => {
                        if (
                            result.data.draw === this.kit_composition.source_table.last_draw
                        ) {
                            if (filtered) {
                                this.kit_composition.source_table.data = result.data.results;
                            } else {
                                for (let product of result.data.results) {
                                    this.kit_composition.source_table.data.push(product);
                                }
                            }

                            this.kit_composition.source_table.total_records = result.data.count;
                        }
                    })
                    .then(() => {
                        this.kit_composition.source_table.loading = false;
                    });
            },

            // Добавление товрара в заказ
            addToKitTargetTable(data, index) {
                for (const [counter, item] of this.kit_composition.target_table.entries()) {
                    if (item.id === data.id) {
                        this.kit_composition.target_table[counter].count++;

                        let count = this.kit_composition.target_table[counter].count;

                        // Скидку учитываем только при продаже и возврате продажи
                        // let discount = this.formData.type === TYPE_SELL ? data.discount : 0;
                        let discount = this.PRICE_ATTR === BASE_PRICE ? data.discount : 0;
                        this.kit_composition.target_table[counter].total_price =
                          parseFloat((data[this.PRICE_ATTR] * count -
                            (data[this.PRICE_ATTR] * count * discount) / 100).toFixed(2));
                        return;
                    }
                }

                let number_inc = this.kit_composition.target_table.length + 1;
                // Скидку учитываем только при продаже и возврате продажи
                // let discount = this.formData.type === TYPE_SELL ? data.discount : 0;
                let discount = this.PRICE_ATTR === BASE_PRICE ? data.discount : 0;
                let price = parseFloat((data[this.PRICE_ATTR] - (data[this.PRICE_ATTR] * discount) / 100).toFixed(2));

                this.kit_composition.target_table.push({
                    number_inc: number_inc,
                    id: data.id,
                    name: data.name,
                    code: data.code,
                    unit: data.unit,
                    discount: discount,
                    base_price: data[this.PRICE_ATTR],
                    count: 1,
                    total_price: price
                });

            },

            // Удаление товара из целеыой таблицы (КОМПЛЕКТ)
            deleteFromKitTargetTable(id) {
                for (const [
                    counter,
                    item
                ] of this.kit_composition.target_table.entries()) {
                    if (item.id === id) {
                        this.kit_composition.target_table.splice(counter, 1);
                        return;
                    }
                }
            },

            // Измнение кол-ва, цены, скидки по товару
            changeCountTargetTable(count, row_count) {
                this.kit_composition.target_table[row_count].count = count;
                this.changeTotalPriceTargetTable(row_count);
            },
            changePriceTargetTable(price, row_count) {
                this.kit_composition.target_table[row_count].base_price = price;
                this.changeTotalPriceTargetTable(row_count);
            },
            changeDiscountTargetTable(discount, row_count) {
                this.kit_composition.target_table[row_count].discount = discount;
                this.changeTotalPriceTargetTable(row_count);
            },

            // Изменение скидки по заказу
            changeDiscountByDocTargetTable(discount) {
                for (const counter in this.kit_composition.target_table) {
                    this.kit_composition.target_table[counter].discount = discount;
                    this.changeTotalPriceTargetTable(counter);
                }
            },

            // Измнение полной цены товара (при измнении любого из парамтров товара)
            changeTotalPriceTargetTable(row_count) {
                let row = this.kit_composition.target_table[row_count];

                let count = row.count;
                let base_price = row.base_price;
                let discount = row.discount;

                this.kit_composition.target_table[row_count].total_price =
                    base_price * count - (base_price * count * discount) / 100;
            },

            // Справочники
            getCustomers() {
                const url = base_url + "/options/customers/";
                this.$http
                    .get(url)
                    .then(result => {
                        this.formSelectOptions.customer = result.data.results;
                    })
            },
            getSuppliers() {
                const url = base_url + "/options/suppliers/";
                this.$http
                    .get(url)
                    .then(result => {
                        this.formSelectOptions.supplier = result.data.results;
                    })
            },
            getStores() {
                const url = base_url + "/options/stores/";
                this.$http
                    .get(url)
                    .then(result => {
                        this.formSelectOptions.store = result.data.results;
                    })
            },
            getAccounts() {
                const url = base_url + "/options/accounts/?without_cash=true";
                this.$http
                    .get(url)
                    .then(result => {
                        this.formSelectOptions.account = result.data.results;
                    })
            },

            // Действия по документу об оплате
            addMoneyOrder() {
                this.formData.money_orders.push({
                    applied: false,
                    account: this.formData.money_orders[0].account,
                    sum: 0,
                    date: new Date()
                });
            },
            deleteMoneyOrder(index) {
                this.formData.money_orders.splice(index, 1);
            },

            handleDataBeforeSave(formData) {
                let data = formData;
                data.positions = [];
                
                for (let item of this.kit_composition.target_table) {
                    if(item.count === null) this.$Message.error('Заполните поле "Количество"');
                    if(item.base_price === null) this.$Message.error('Заполните поле "Цена"');
                    if(item.discount === null) this.$Message.error('Заполните поле "Скидка"');
                    data.positions.push({
                        product: item.id,
                        name: item.name,
                        code: item.code,
                        amount: item.count.toFixed(3),
                        base_price: item.base_price.toFixed(2),
                        discount: item.discount.toFixed(2),
                        total_price: item.total_price.toFixed(2)
                    });
                }

                formData.money_orders.forEach((item, idx) => {
                    data.money_orders[idx] = {
                        applied: item.applied,
                        account: item.account,
                        sum: item.sum.toFixed(2),
                        date: item.date
                    };
                });

                data.total_sum = this.total_sum.toFixed(2);
                data.paid_sum = this.paid_sum.toFixed(2);
                data.total_discount = this.total_discount;
                data.total_discount_sum = this.total_discount_sum;

                return data
            },

            save() {
                let url = this.base_view_url;
                let http_method = "post";
                let data = this.handleDataBeforeSave(this.formData);

                switch (this.action) {
                    case "create":
                        http_method = "post";
                        url = this.base_view_url;
                        break;
                    case "edit":
                        http_method = "put";
                        url = `${this.base_view_url}${this.id}/`;
                        break;
                }

                this.loading = true;
                this.$http[http_method](url, data)
                    .then(response => {
                        this.$Message.success("Успешно сохранено");
                        this.$router.push({
                            name: "product_order_detail",
                            params: {id: response.data.id}
                        });
                        // this.showDetail(response.data.id);
                        // if (this.action === "create") {
                        //   this.$emit("change", response.data.id);
                        // }
                        // this.$emit("reload_table");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            formatNumber(number) {
                return formatNumber(number);
            },

            fetchDefaultCustomer(counterpart) {
                const path = "/customers/?default=true";
                this.$http
                    .get(base_url + path)
                    .then(result => {
                        if (result.data.results.length > 0) {
                            if (counterpart === 'sender') {
                                this.formData.sender.id = result.data.results[0].id;
                            } else if (counterpart === 'recipient') {
                                this.formData.recipient.id = result.data.results[0].id;
                            }
                        }
                    })
            },
            fetchDefaultSupplier(counterpart) {
                const path = "/suppliers/?default=true";
                this.$http
                    .get(base_url + path)
                    .then(result => {
                        if (result.data.results.length > 0) {
                            if (counterpart === 'sender') {
                                this.formData.sender.id = result.data.results[0].id;
                            } else if (counterpart === 'recipient') {
                                this.formData.recipient.id = result.data.results[0].id;
                            }
                        }
                    })
            },
            fetchDefaultStore(counterpart) {
                const path = "/stores/?default=true";
                this.$http
                    .get(base_url + path)
                    .then(result => {
                        if (result.data.results.length > 0) {
                            if (counterpart === 'sender') {
                                this.formData.sender.id = result.data.results[0].id;
                            } else if (counterpart === 'recipient') {
                                this.formData.recipient.id = result.data.results[0].id;
                            }
                        }
                    })
            },

            fetchAccountOfStore(store_id) {
                const path = "/accounts/?store=" + store_id;
                this.$http
                    .get(base_url + path)
                    .then(result => {
                        if (result.data.results.length > 0) {
                            for (const counter in this.formData.money_orders) {
                                this.formData.money_orders[counter].account =
                                    result.data.results[0].id;
                            }
                        }
                    })
            },

            setOrderDate(date_str, date2) {
                this.formData.order_date = date_str;
            },

            validateForm: base.methods.validateForm,

            fetchInitialData() {
                this.$http
                    .get(this.base_view_url + this.id)
                    .then(response => {
                        this.formData = response.data;

                        if (this.formData.state) {
                            this.is_order = true;
                        }
                        for (let field in this.formData) {
                            if (field === 'positions') {
                                this.formData[field] = response.data[field];

                                // Заполняем времменую таблицу выбранных позицый для корректного редактирования
                                for (const item of this.formData[field]) {
                                    let number_inc = this.kit_composition.target_table.length + 1;
                                    this.kit_composition.target_table.push({
                                        number_inc: number_inc,
                                        id: item.id,
                                        name: item.name,
                                        code: item.code,
                                        // unit: response.data[field].unit,
                                        unit: item.unit,
                                        discount: item.discount,
                                        base_price: item.base_price,
                                        count: item.amount,
                                        total_price: item.total_price
                                    });
                                }

                            } else {
                                this.formData[field] = response.data[field];
                            }
                        }

                        // this.fetchSchema();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            changeState(newVal) {
                this.formData.applied = newVal && newVal === "closed";
            },

            changePaymentSum(newValAtr, idx) {
                let newVal = parseFloat(newValAtr.replace(" ", ""));
                if (newVal) {
                    // console.log("newVal: "+newVal);
                    this.$set(this.formData.money_orders[idx], 'sum', newVal);
                    // this.formData.money_orders[idx].sum = parseFloat(newVal);

                    let sum = 0;
                    this.formData.money_orders.forEach((val) => {
                        sum += val.sum;
                    });
                    // console.log("if 1");
                    // console.log("1 sum: " + sum);
                    // console.log("1 this.total_sum: " + this.total_sum);

                    if (sum > this.total_sum) {
                        let delta = sum - this.total_sum;
                        let new_sum = newVal - delta;
                        // console.log("delta: " + delta);
                        // console.log("new_sum: " + new_sum);
                        // console.log("if2 nextTick");
                        this.$nextTick(() => {
                            this.$set(this.formData.money_orders[idx], 'sum', new_sum);
                        })
                    }

                } else {
                    this.$nextTick(() => {
                        // console.log("else nextTick");
                        this.$set(this.formData.money_orders[idx], 'sum', 0);
                    })
                }
            }
        },
        watch: {
            // Поиск товара для набора (КОМПЛЕКТ)
            "kit_composition.search_value": function () {
                this.kit_composition.source_table.current_page = 1;
                this.fetchProductsForKit(true);
            },
            // Прокрутка товара по нажатию кнопки "Больше
            "kit_composition.source_table.current_page": function () {
                this.fetchProductsForKit();
            },
            is_order: function (newVal) {
                this.formData.state = newVal ? "new" : "";
            },
            // Подставляем общую сумму в оплату
            total_sum: function (newVal) {
                this.formData.money_orders.forEach((val, idx) => {
                    if (idx === 0) {
                        this.$set(this.formData.money_orders[idx], 'sum', newVal);
                    } else {
                        this.$set(this.formData.money_orders[idx], 'sum', 0);
                    }
                });

            },
            // Если магазин (отправитель либо получатель) выбран - подтягиваем связанный счет в оплату
            "formData.sender.id": function (newVal) {
                if (this.formData.sender.type === "store")
                    this.fetchAccountOfStore(newVal);

                this.validateForm();
                // this.isChanged = true;
            },
            "formData.recipient.id": function (newVal) {
                if (this.formData.recipient.type === "store")
                    this.fetchAccountOfStore(newVal);

                this.validateForm();
                // this.isChanged = true;
            },

            // Используется для формы редактирования
            "formData.state": function (newVal) {
                this.isChanged = true;
            },
            "formData.order_date": function (newVal) {
                this.isChanged = true;
            },
            "formData.applied": function (newVal) {
                this.isChanged = true;
            },
            "formData.description": function (newVal) {
                this.isChanged = true;
            },
        },
        mounted() {
            switch (this.$route.name) {
                case "product_order_create":
                    this.action = 'create';
                    this.fetchProductsForKit();
                    break;
                case "product_order_edit":
                    this.action = 'edit';
                    this.id = this.$route.params.id;
                    this.fetchInitialData();
                    break;
            }

            this.getStores();
            this.getAccounts();

            // this.getSuppliers();

            switch (this.$route.query["type"]) {
                case TYPE_SELL:
                    this.formData.type = TYPE_SELL;
                    this.formData.sender.type = "store";
                    this.formData.recipient.type = "customer";
                    this.getCustomers();
                    this.fetchDefaultStore('sender');
                    this.fetchDefaultCustomer('recipient');
                    this.PRICE_ATTR = BASE_PRICE;
                    break;
                case TYPE_PURCHASE:
                    this.formData.type = TYPE_PURCHASE;
                    this.formData.sender.type = "supplier";
                    this.formData.recipient.type = "store";
                    this.getSuppliers();
                    this.fetchDefaultStore('recipient');
                    this.fetchDefaultSupplier('sender');
                    this.PRICE_ATTR = PURCHASE_PRICE;
                    break;
                case TYPE_RETURN_SELL:
                    this.formData.type = TYPE_RETURN_SELL;
                    this.formData.sender.type = "customer";
                    this.formData.recipient.type = "store";
                    this.getCustomers();
                    this.fetchDefaultStore('recipient');
                    this.fetchDefaultCustomer('sender');
                    this.PRICE_ATTR = BASE_PRICE;
                    break;
                case TYPE_RETURN_PURCHASE:
                    this.formData.type = TYPE_RETURN_PURCHASE;
                    this.formData.sender.type = "store";
                    this.formData.recipient.type = "supplier";
                    this.getSuppliers();
                    this.fetchDefaultStore('sender');
                    this.fetchDefaultSupplier('recipient');
                    this.PRICE_ATTR = PURCHASE_PRICE;
                    break;
                // default:
                //   this.formData.type = "sell";
                //   this.formData.sender.type = "store";
                //   this.formData.recipient.type = "customer";
                //   this.getCustomers();
                //   this.fetchDefaultCustomer('recipient');
            }

            this.loading = false;
        }
    };
</script>

<style scoped>
  .form__order_number {
    width: 100px;
    border-top-width: 0;
    border-left-width: 0;
    border-right-width: 0;
    border-bottom-style: dashed;
    border-bottom-width: 2px;
  }

  .total_row {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px
  }

  .no-select {
    text-align: center;
    font-size: 28px;
    color: rgba(191, 191, 191, .87);
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .card-container__one-col-table {
    padding: 10px 20px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }

  .switch-custom span.ivu-switch {
    margin-left: 0;
  }

  @media screen and (max-width: 1500px) {
    .total_row {
      font-size: 14px
    }

    .no-select {
      font-size: 20px;
    }
  }


  @media screen and (max-width: 991px) {
    .card-container__one-col-table {
      padding: 0;
      box-shadow: none;
      max-height: calc(100vh - 200px);
      overflow-y: auto;
      /*margin-bottom: 30px;*/
    }

    .mobile-table .card-container {
      margin: 0 5px 10px 5px;
    }

    .mobile-table .card-container p {
      margin-bottom: 10px;
    }

    .target_table .ivu-input-number {
      padding: 2px 5px;
      font-size: 12px;
      margin-left: 10px;
      max-width: 80px;
      width: auto;
    }

    .no-select {
      margin-top: 50px;
      margin-bottom: 50px;
    }

    @media screen and (max-width: 767px) {
      .select-filter {
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid rgba(206, 206, 206, 0.3);
        border-bottom: 1px solid rgba(206, 206, 206, 0.3);
      }
    }


  }


</style>

<style>
  .kit_source_table_column {
    cursor: pointer;
  }

  .ls_source_table {
    height: 699px;
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #dcdee2 !important;
  }

  .datepicker_input {
    width: 220px;
  }

  .mobile-table .ivu-table .ivu-table-row {
    background-color: rgba(206, 206, 206, 0.2);
  }

  @media screen and (max-width: 1900px) {
    .datepicker_input {
      width: 180px;
    }
  }

  @media screen and (max-width: 991px) {
    .ivu-input-number-handler-wrap {
      display: none;
    }

    .mobile-table .ivu-input-number-input-wrap {
      height: auto;
    }

    .mobile-table .ivu-input-number-input {
      height: auto;
      line-height: 1;
    }

    .count-card {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      padding: 10px;
      margin: 5px 5px 15px 5px;
      border-radius: 25px;
    }

  }

  @media screen and (min-width: 768px) {
    .ivu-col-span-md-0 {
      display: block;
      width: auto;
    }
  }

  @media screen and (max-width: 767px) {
    .datepicker_input {
      width: 100%;
    }
  }

  @media screen and (max-width: 575px) {
    .text-right {
      text-align: left;
    }


  }


</style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrderForm.vue